import OpportunityUsers from "./OpportunityUsers";

export default OpportunityUsers;
